import Swal from "sweetalert2";

require('./bootstrap');
//require('./ckeditor');

require('pickadate/lib/compressed/picker');
require('pickadate/lib/compressed/picker.date');
require('pickadate/lib/compressed/picker.time');
require('pickadate/lib/translations/fr_FR');

require('jquery-ui/ui/widgets/autocomplete');
require('owl.carousel');

window.Swal = require('sweetalert2');
import Sortable from 'sortablejs';

import tinymce from 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/plugins/hr/plugin';
import 'tinymce/plugins/autoresize/plugin';
import 'tinymce/plugins/table/plugin';
import 'tinymce/plugins/code/plugin';
import 'tinymce/plugins/image/plugin';
import 'tinymce/plugins/media/plugin';
import 'tinymce/plugins/lists/plugin';
import 'tinymce/plugins/link/plugin';
import 'tinymce/plugins/visualblocks/plugin';
import 'tinymce/plugins/imagetools/plugin';
import 'tinymce/plugins/paste/plugin';
import './fr_FR';

window.Vue = require('vue');
import FilesManager from "./components/FilesManager";

/**
 * Constantes
 */
const API_TOKEN = document.head.querySelector("[name~=api-token][content]").content;
const CSRF_TOKEN = document.head.querySelector("[name~=csrf-token][content]").content;
const DOMAIN = document.head.querySelector("[name~=domain][content]").content;

$(function() {

    let tMce = document.getElementsByClassName('tiny-editor');
    if(tMce.length) {
        tinymce.init({
            selector: '.tiny-editor',
            plugins: 'hr, autoresize, charmap, table, code, image, media, lists, link, visualblocks, imagetools, paste',
            toolbar: 'undo redo | bold italic underline strikethrough | fontsizeselect formatselect forecolor backcolor | alignleft aligncenter alignright alignjustify | link image media | table numlist bullist | hr charmap | visualblocks code',
            image_uploadtab: true,
            images_upload_url: '/api/edit-images',
            images_upload_base_path: DOMAIN,
            language: 'fr_FR',
            paste_as_text: true,
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            image_class_list: [
                {title: 'Aucune', value: ''},
                {title: 'Image 100%', value: 'echec-image-3'},
                {title: 'Image 60%', value: 'echec-image'},
                {title: 'Image 40%', value: 'echec-image-2'},
                {title: 'Image 20%', value: 'echec-image-4'},
            ],
            tiny_pageembed_classes: [
                {title: 'Aucune', value: ''},
                {title: 'Media 100%', value: 'echec-image-3'},
                {title: 'Media 60%', value: 'echec-image'},
                {title: 'Media 40%', value: 'echec-image-2'},
                {title: 'Media 20%', value: 'echec-image-4'},
            ]
        });

    }

    $('.delete-form').on('submit', confirmDelete);
    $('.duplicate-form').on('submit', confirmDuplicate);

    $("#owl-sliders").owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        items : 1,
        itemsDesktop : false,
        itemsDesktopSmall : false,
        itemsTablet: false,
        itemsMobile : false,
        loop: true,
    });

    /**
     * Sortable
     */
    let sortableContainer = document.getElementById('sortable-container');
    if(sortableContainer) {
        Sortable.create(sortableContainer, {
            ghostClass: 'sortable-ghost-background',
            handle: '.sortable-handle',
            animation: 150,
            onEnd: function(e) {
                let dropEl = e.item;

                fetch(dropEl.dataset.moveUrl, {
                    headers: getHeaders(),
                    method: 'PUT',
                    body: JSON.stringify({new_index: e.newIndex})
                }).then(res => res.json())
                    .catch(function(error) {
                        console.log(error)
                    });
            }
        });
    }


    /**
     * Sortable pour gestion du menu
     */
    let sortableContainers;
    sortableContainers = document.querySelectorAll(".nested-sortable-container");
    for (var i = 0; i < sortableContainers.length; i++) {
        Sortable.create(sortableContainers[i], {
            group: {
                name: "sortable-list-2",
                pull: true,
                put: true,
            },
            forceFallback: true,
            handle: '.sortable-handle',
            ghostClass: 'sortable-ghost',
            animation: 150,
            onEnd: function(e) {
                let dropEl = e.item;
                let targetEl = e.to;


                let newParent = targetEl.dataset.newParent;
                let dropElSubmenu = $('#submenu-' + dropEl.id);
                let dropElSubmenuList = $('#submenu-list-' + dropEl.id);

                if (newParent == "") {
                    dropElSubmenu.removeClass('d-none');
                } else {
                    dropElSubmenuList.html("");
                    dropElSubmenu.addClass('d-none');
                }
                fetch(dropEl.dataset.moveUrl, {
                    headers: getHeaders(),
                    method: 'PUT',
                    body: JSON.stringify({new_index: e.newIndex, new_parent: newParent})
                })
                .then(res => res.json())
                .catch(function(error) {
                    console.log(error)
                });
            }
        });
    }

    /**
     * Génération de slug
     */
    $('#slugenerator').on('click',  function(e){
        e.preventDefault();
        var source = $('#' + $(this).data("source"));
        var target = $('#' + $(this).data("target"));

        target.val(string_to_slug(source.val()));
    });

    /**
     * Suppression ligne tableau
     */
    $(document).on('click', '.delete-current-row', function(e){
        e.preventDefault();
        $(this).closest("tr").remove();
    });

    /**
     * Datepicker
     */

    $('.datepicker').pickadate({
        format: 'dd/mm/yyyy',
        formatSubmit: 'dd/mm/yyyy',
        hiddenName: true,
        selectMonths: true,
        selectYears: 2,
    });

    $('.datepicker-limited').pickadate({
        format: 'dd/mm/yyyy',
        formatSubmit: 'dd/mm/yyyy',
        hiddenName: true,
        selectMonths: true,
        selectYears: 80,
        max: new Date()
    });

    $('.datepicker').on('change', function () {
        if ($(this).attr('id') === 'start_at' && $('#end_at').length) {
            $('#end_at').pickadate('picker').set('min',$(this).val());
        }
        if ($(this).attr('id') === 'end_at' && $('#start_at').length) {
            $('#start_at').pickadate('picker').set('max',$(this).val());
        }

        if ($(this).attr('id') === 'register_start_at' && $('#register_end_at').length) {
            $('#register_end_at').pickadate('picker').set('min',$(this).val());
        }

        if ($(this).attr('id') === 'register_end_at' && $('#register_start_at').length) {
            $('#register_start_at').pickadate('picker').set('max',$(this).val());
        }
    });

    /**
     * Autocomplete
     */
    $('input.model-autocomplete').each(function(i, el) {
        el = $(el);
        el.autocomplete({
            minLength: 0,
            source : function(request, response){
                $.ajax({
                    url : el.data("api-url"),
                    type: 'get',
                    dataType : 'json',
                    minLength: 0,
                    headers: getHeaders(),
                    data: {...{ q: request.term }, ...el.data("filters") === undefined ? {} : el.data("filters")},
                    success: function(data) {
                        response($.map(data, function(item) {
                            return Object.assign(item, {
                                label: item[el.data("label")] ?? '',
                                value: item[el.data("value")] ?? '',
                            })
                        }))
                    }
                });
            },
            change: function (event, item) {
                if(!item.item){
                    if(el.data("force-value") == true) {
                        $(event.target).val("");
                    }
                    if ($('#'+el.data("target-input-id")).length) {
                        $('#'+el.data("target-input-id")).val("")
                    }
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function(e, item) {
                if ($('#'+el.data("target-input-id")).length) {
                    $('#'+el.data("target-input-id")).val(item.item.id)
                }
            }
        }).focus(function() {
            el.autocomplete("search", '');
        });
    });
});

/**
 * Confirmation avant suppression
 *
 * https://github.com/sweetalert2/sweetalert2
 */

function confirmDelete(e) {
    e.preventDefault();
    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, supprimer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            this.submit()
        }
    })
}

function confirmDuplicate(e) {
    e.preventDefault();
    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: "L'élément sera dupliqué et vous serez invité à modifier les informations",
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Dupliquer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            this.submit()
        }
    })
}

/**
 * Récupération des headers commun
 */
function getHeaders() {
    return {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        'Accept': 'application/json',
        'Authorization': `Bearer ${API_TOKEN}`,
    }
}

/**
 * Création slug depuis chaine de caractère
 * @param str
 * @returns {string}
 */
function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

new Vue({
    el: '#app',
    components : {FilesManager},
});
